export const setInitialPageview = () => ({
  type: `SET_INITIAL_PAGEVIEW`
});

export default {
  setInitialPageview,
};